import {Link} from "react-router-dom";
import React from "react";
import Modal from "../../common/Modal/Modal";

const digitalizzazioneCustomModalSuccess = (props) => {
  const {t, embed} = props;
  return (
    <Modal
      icon={!props.isError ? "gc-icon-functional-check-2-col" : "gc-icon-functional-attention-2-col" }
      show={true}
      descriptionClass={"success-modal-text paragraph-main-fs8"}
      content= {
        props.isError ? (
          <p>
            {props.errorMessage ? t(props.errorMessage) : t("cases.generic_error")}
          </p>
        ) : (
          <div className="content">
            {t(props.content)}
          </div>
        )
      }
      type={embed ? "a" : "link"}
      onFirstClick={embed ? (e: React.SyntheticEvent) => {
        e.preventDefault();
        window.location.reload();
      } : null }
      to={"/"}
      linkTitle={ embed ? t("common.close") : t("common.hoCapito")}
    />
  )
}

export default digitalizzazioneCustomModalSuccess;
